// Singleton that captures the browser's beforeinstallprompt event.
// Call captureDeferredPrompt() once on app load, then call triggerInstall()
// from anywhere (InstallPrompt, Settings, etc.)

let _prompt = null;

export function captureDeferredPrompt() {
  if (typeof window === "undefined") return;
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    _prompt = e;
    window.dispatchEvent(new CustomEvent("pwa-installable"));
  });
  window.addEventListener("appinstalled", () => {
    _prompt = null;
  });
}

export function canInstall() {
  return !!_prompt;
}

export async function triggerInstall() {
  if (!_prompt) return false;
  _prompt.prompt();
  const { outcome } = await _prompt.userChoice;
  _prompt = null;
  return outcome === "accepted";
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

export function isIOSSafari() {
  if (typeof window === "undefined") return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}
